import { FC } from 'react';
import SwiperCore from 'swiper';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperOptions } from 'swiper/types/swiper-options';
import BusinessButton from '../business-button/business-button';

import { COLORS, POSITION } from '../business-button/business-button.constants';
import styles from './business-hub-hero-industry.module.scss';

SwiperCore.use([Autoplay]);

export interface BusinessHubHeroIndustryProps {
    backgroundColor?: string;

    content?: {
        title?: string;
        description?: string;
        ctaLink?: string;
    };

    listImageHero?: {
        image?: string;
    }[];
}

const BusinessHubHeroIndustry: FC<BusinessHubHeroIndustryProps> = (props) => {
    const { backgroundColor, content, listImageHero = [] } = props;

    const options: SwiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: 40,
        allowTouchMove: true,
        noSwiping: false,
        freeMode: false,
        loop: true,
        effect: 'fade',
        navigation: true,
        pagination: false,
        speed: 3000,
        autoplay: {
            delay: 1,
            disableOnInteraction: false,
        },
        breakpoints: {
            998: {
                spaceBetween: 42,
                watchOverflow: true,
            },
        },
    };
    return (
        <div className={styles.container}>
            <div className={styles.wrapperContent}>
                <div className={styles.wrapperText}>
                    <div className={styles.contentText}>
                        <div className={styles.title} dangerouslySetInnerHTML={{ __html: content?.title || '' }}></div>
                        <div className={styles.description} dangerouslySetInnerHTML={{ __html: content?.description || '' }}></div>
                        {content?.ctaLink ? (
                            <div className={styles.btnHero}>
                                <BusinessButton position={POSITION.LEFT} color={COLORS.MINT} link={content?.ctaLink} buttonText="Get started" target="_blank"></BusinessButton>
                            </div>
                        ) : null}
                    </div>
                </div>

                <div className={styles.wrapperImage}>
                    <div className={styles.containerImage}>
                        <div className={styles.wrapperImage}>
                            {listImageHero ? (
                                <Swiper {...options}>
                                    {listImageHero.map((item, index) => {
                                        return (
                                            <SwiperSlide key={index}>
                                                {item.image && (
                                                    <div className={styles.item}>
                                                        <img src={item.image} alt="image"></img>
                                                    </div>
                                                )}
                                            </SwiperSlide>
                                        );
                                    })}
                                </Swiper>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BusinessHubHeroIndustry;
